<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
  export default {
    name: 'App'
  };
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/App.vue